// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BreadcrumbSiteStructure__separator":"bbm_a bhy_fm"};